import VerifiedTokenIcon from "../../public/svg/verified-token.svg";

interface VerifiedTokenProps {
  className?: string;
  size?: number | string;
}
export const VerifiedToken = ({ className, size }: VerifiedTokenProps) => (
  <VerifiedTokenIcon
    className={className}
    css={`
      color: var(--creator-slug-color);
      margin-left: ${size
        ? typeof size === "number"
          ? `${size / 5}px`
          : `calc(${size} / 5)`
        : `0.2em`};
      height: ${size ? (typeof size === "number" ? `${size}px` : size) : `1em`};
      width: ${size
        ? typeof size === "number"
          ? `${size}px`
          : size
        : `1em`}; ;
    `}
  />
);
